import { Component, Prop, Vue } from 'nuxt-property-decorator';
import * as dayjs from 'dayjs';
import { mapGetters } from 'vuex';

import IconAlertCircle from '../../assets/svg/alert-circle.svg';
import Tooltip from '../tooltips/index.vue';

@Component<TimezoneDeltaTooltip>({
  components: {
    IconAlertCircle,
    Tooltip
  }
})
export default class TimezoneDeltaTooltip extends Vue {
  @Prop({ type: Object, default: null })
  date!: dayjs.Dayjs

  @Prop({ type: String, required: true })
  timezone!: string

  @Prop({ type: Boolean, default: false })
  hideOffset!: boolean

  @Prop({ type: Boolean, default: false })
  short!: boolean

  @Prop({ type: String, default: 'center' })
  direction!: 'left' | 'right' | 'center';

  @Prop({ type: Boolean, default: false })
  isMobile!: boolean;

  @Prop({ type: String, default: '' })
  iconClass!: string;

  showTooltip: boolean = false;

  get user(): any {
    return mapGetters({
      user: 'members/me',
    }).user;
  }

  get formattedDate() {
    const date = this.date?.toDate();
    if (!date) return undefined;

    return this.formatDate(date, this.timezone);
  }

  get shortTimezoneName() {
    let date = this.date?.toDate();
    if (!date) date = new Date();

    return this.getTimeZoneName(this.timezone, date);
  }

  get userTimezone() {
    const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return this.user?.currentOrganization?.addresses.getItem(0)?.timezone || browserTimezone;
  }

  get userShortTimezoneName() {
    if (!this.userTimezone) return undefined;
    const date = this.date?.toDate();
    if (!date) return undefined;

    return this.getTimeZoneName(this.userTimezone, date);
  }

  get userFormattedDate() {
    const date = this.date?.toDate();
    if (!date) return undefined;

    return this.formatDate(date, this.userTimezone);
  }

  get locale() {
    // @ts-ignore
    return this.$LanguageService?.currentLanguage?.replace('_', '-') || 'en-us';
  }

  formatDate(date: Date, timeZone: string) {
    const options = {
      timeZone,
      month: 'short',
      day: 'numeric',
      weekday: 'short',
      hour: 'numeric',
      minute: 'numeric',
    };

    return (new Intl.DateTimeFormat(this.locale, options)).format(date);
  }

  getTimeZoneName(timeZone: string, date: Date) {
    const options = {
      timeZone,
      timeZoneName: 'short',
    };

    return (new Intl.DateTimeFormat(this.locale, options))
      .formatToParts(date)
      .find(({ type }) => type === 'timeZoneName')
      ?.value;
  }

}
